"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectMembersPage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const antd_1 = require("antd");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const ProjectParticipantModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ProjectParticipantModalComponent");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const CurrentProjectProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentProjectProvider");
const icons_1 = require("@ant-design/icons");
const ProjectMembersTable_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/members/ProjectMembersTable");
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const i18_1 = require("src/configeek_assets/src/i18");
// 10000 - ereir-a6cut-yv5ur-iibqy-fj6xb-t2e6g-42r2e-lnpzf-pooaf-nmbme-jae
// 10002 - 4lbqq-spd26-fkrdo-rbcde-ft7oe-ygssw-xuuze-2b7px-oacyp-xasrx-zae
// plug -  ms353-v3owf-bwxfw-klekb-y2uur-uakdy-a5q2c-ug7sk-px3ir-w3x62-pae
const ProjectMembersPage = () => {
    const isMounted = (0, isMounted_1.default)();
    const projectParticipantsDataContext = (0, ProjectParticipantsDataProvider_1.useProjectParticipantsDataContext)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const hasProjectMemberAccess = appICUtils_1.ParticipantUtils.hasProjectMemberAccess(currentProjectContext.projectData.view.participant);
    const { inProgress, loaded } = projectParticipantsDataContext.participants.status;
    (0, react_1.useEffect)(() => {
        if (hasProjectMemberAccess) {
            projectParticipantsDataContext.fetchParticipants();
        }
    }, [hasProjectMemberAccess]);
    //invite participant
    const [inviteProjectParticipantModalVisible, setInviteProjectParticipantModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onInviteProjectParticipantModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setInviteProjectParticipantModalVisible({ visible: false });
        }
    }, [isMounted]);
    const onClickInviteProjectParticipant = () => {
        setInviteProjectParticipantModalVisible({ visible: true, nonce: inviteProjectParticipantModalVisible.nonce + 1 });
    };
    if (!hasProjectMemberAccess) {
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.PageHeader, { title: "Members" }),
            React.createElement(PageContent_1.PageContent, { topDivider: true },
                React.createElement(antd_1.Result, { subTitle: i18_1.i18.project.members.error.table.noAccess.msg, icon: React.createElement(React.Fragment, null), extra: React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PATH__PROJECTS },
                        React.createElement(antd_1.Button, null,
                            React.createElement("span", null, i18_1.i18.project.members.error.table.noAccess.backToProjectsLink))) })));
    }
    const inviteProjectParticipantHeaderButton = React.createElement(antd_1.Button, { icon: React.createElement(icons_1.PlusOutlined, null), onClick: onClickInviteProjectParticipant, disabled: inProgress },
        React.createElement("span", null, i18_1.i18.project.members.common.header.inviteButton));
    const refreshHeaderButton = React.createElement(antd_1.Button, { icon: React.createElement(icons_1.ReloadOutlined, null), onClick: projectParticipantsDataContext.fetchParticipants, disabled: inProgress });
    const pageHeaderExtra = React.createElement(React.Fragment, null,
        React.createElement(ProjectParticipantModalComponent_1.ProjectParticipantModalComponent, { key: `inviteProjectParticipant${inviteProjectParticipantModalVisible.nonce}`, visible: inviteProjectParticipantModalVisible.visible, onDestroy: onInviteProjectParticipantModalDestroy, projectView: currentProjectContext.projectData.view.project }),
        React.createElement(antd_1.Space, null,
            inviteProjectParticipantHeaderButton,
            refreshHeaderButton));
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Members", extra: pageHeaderExtra }),
        React.createElement(PageContent_1.PageContent, { topDivider: true },
            React.createElement(PageContent_1.PageContent.Card, null,
                React.createElement(ProjectMembersTable_1.ProjectMembersTable, null))));
};
exports.ProjectMembersPage = ProjectMembersPage;
